import {call, put, takeEvery} from 'redux-saga/effects';
import MyTopPerformingGamesApi from '../../api/MyTopPerformingGamesApi';
import myTopPerformingGamesActions from '../../actions/fortnite-game/myTopPerformingGames.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getTopPerformingGames(action) {
    try {
        const {data} = yield call(MyTopPerformingGamesApi.getTopPerformingGames, action.payload);
        yield put(
            myTopPerformingGamesActions.getTopPerformingGamesSuccess({
                data,
                error: data.length ? undefined : NO_DATA_ERROR_CODE,
                ...action.payload
            })
        );
    } catch (e) {
        yield put(
            myTopPerformingGamesActions.getTopPerformingGamesFailed(getErrorCodeFromResponse(e), {
                ...action.payload,
                ...e
            })
        );
    }
}

function* myTopPerformingGamesSaga() {
    yield takeEvery(
        myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES,
        getTopPerformingGames
    );
}

export default myTopPerformingGamesSaga;
